import React from 'react';
const LoadingSpinner = ({ message = 'Loading...' }) => {
    return (React.createElement("div", { className: "text-center", style: { padding: '50px 0' }, role: "status", "aria-live": "polite" },
        React.createElement("i", { className: "fa fa-spinner fa-spin fa-3x text-primary", "aria-hidden": "true" }),
        React.createElement("p", { style: { marginTop: '20px', fontSize: '16px', color: '#666' } }, message)));
};
export default LoadingSpinner;
